import React, { useEffect, useState } from "react";
import {
  Container,
  Modal,
  ModalBody,
  Button,
  Card,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  ModalFooter,
  Spinner,
  Badge,
} from "reactstrap";
import Header from "components/Headers/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  adminEarningStats,
  groupChatAction,
  oneOnOneChatAction,
} from "store/actions/additionalEarningAction";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const A4BChat = (args) => {
  const [currentActiveTab, setCurrentActiveTab] = useState("1-on1chats");

  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };
  const [modal1, setModal1] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [selectedObjectIndex, setSelectedObjectIndex] = useState(null);
  const [selectedObjectIndex2, setSelectedObjectIndex2] = useState(null);
  const [selectedObjectIndex3, setSelectedObjectIndex3] = useState(null);

  const infoPoints = [
    "In this module, the admin monitors chat statistics, athletes' total earnings, and payout details.",
  ];
  const subPoints = [];
  const infoTitle = "A4B Chat Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const handleButtonClick3 = (index) => {
    setSelectedObjectIndex3(index);
    setModal1(!modal1);
  };

  const handleButtonClick = (index) => {
    setSelectedObjectIndex(index);
    setModal2(!modal2);
  };

  const handleButtonClick2 = (index) => {
    setSelectedObjectIndex2(index);
    setModal3(!modal3);
  };

  const {
    oneononechat,
    groupchat,
    adminStats,
    lastDocumentOneononechat,
    hasMoreOneononechat,
    lastDocumentGroupchat,
    hasMoreGroupchat,
  } = useSelector((state) => state.earnings);
  const [loader, setLoader] = useState({
    data: false,
    loadMore: false,
    filter: false,
  });

  let dispatch = useDispatch();

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      oneOnOneChatAction("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);

  const handleGetOneOnOneChat = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      oneOnOneChatAction("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreOneOnOneChat = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      oneOnOneChatAction(lastDocumentOneononechat, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleGetGroupChat = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      groupChatAction("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreGroupChat = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      groupChatAction(lastDocumentGroupchat, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleGetAdminEarningStats = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      adminEarningStats("2024", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };

  // Table configurations
  const oneOnOneChatColumns = [
    "Athlete id",
    "Athlete name",
    "Fan name",
    "Created at",
    "Amount",
    "Status",
  ];

  const oneOnOneChatKeyMap = {
    "Athlete id": "athleteId",
    "Athlete name": "athleteName",
    "Fan name": "fanName",
    "Created at": "createdAt",
    Amount: "amount",
    Status: "status",
  };

  const transformedOneOnOneChat = oneononechat.map((val) => {
    const createdAt = val?.created_at?.seconds
      ? new Date(val.created_at.seconds * 1000)
      : null;
    let statusColor =
      val.status === "rejected"
        ? "danger"
        : val.status === "payment pending"
        ? "primary"
        : "success";

    return {
      athleteId: val?.athleteData?.athleteID || "N/A",
      athleteName: `${val?.athleteData?.first_name || "N/A"} ${
        val?.athleteData?.last_name || ""
      }`.trim(),
      fanName: `${val?.fanData?.first_name || "N/A"} ${
        val?.fanData?.last_name || ""
      }`.trim(),
      createdAt: createdAt
        ? createdAt.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }) +
          " " +
          createdAt.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : "N/A",
      amount: `${val?.paid_amount?.value || "0"}$`,
      status: (
        <Badge color={statusColor} className={`bg-${statusColor} text-white`}>
          {val.status === "rejected" ? "rejected" : val.status}
        </Badge>
      ),
      originalData: val,
    };
  });

  const groupChatColumns = [
    "Athlete id",
    "Athlete name",
    "Manager",
    "Per person",
    "Total",
    "Status",
  ];

  const groupChatKeyMap = {
    "Athlete id": "athleteId",
    "Athlete name": "athleteName",
    Manager: "manager",
    "Per person": "perPerson",
    Total: "total",
    Status: "status",
  };

  const transformedGroupChat = groupchat.map((val) => {
    let statusColor = val.status === "accepted" ? "primary" : "success";
    return {
      athleteId: val?.athleteData?.athleteID || "N/A",
      athleteName:
        `${val?.athleteData?.first_name} ${val?.athleteData?.last_name}` ||
        "N/A",
      manager: val?.timeslotData?.managerEmail || "N/A",
      perPerson: `${val?.timeslotData?.payments?.[0]?.paid_amount || "0"}$`,
      total: `${val?.paid_amount?.value || "0"}$`,
      status: (
        <Badge color={statusColor} className={`bg-${statusColor} text-white`}>
          {val.status === "accepted" ? "accepted" : val.status}
        </Badge>
      ),
      originalData: val,
    };
  });

  const payoutsColumns = ["Athlete pay out", "Admin pay", "Fan paymnet"];

  const payoutsKeyMap = {
    "Athlete pay out": "athletePayout",
    "Admin pay": "adminPay",
    "Fan paymnet": "fanPayment",
  };

  const fanListColumns = ["Fan Name", "Email", "Paid"];

  const fanListKeyMap = {
    "Fan Name": "name",
    Email: "email",
    Paid: "paid",
  };

  const statsColumns = [
    "",
    "Total # of Chats by month",
    "How many Instant chats",
    "How many Chats by appt,",
    "Average $ per chat",
  ];

  const statsKeyMap = {
    "": "dateRange",
    "Total # of Chats by month": "totalChats",
    "How many Instant chats": "instantChats",
    "How many Chats by appt,": "appointmentChats",
    "Average $ per chat": "chatAverage",
  };

  const transformedStats = adminStats.map((items) => ({
    dateRange: items.dateRange,
    totalChats: items.instantChats + items.appointmentChats,
    instantChats: items.instantChats,
    appointmentChats: items.appointmentChats,
    chatAverage: items.chatAverage,
  }));

  const getPayoutData = (value) => [
    {
      athletePayout: value?.payouts?.athlete || "0$",
      adminPay: value?.payouts?.adminCut || "0$",
      fanPayment: value?.payouts?.fan || "0$",
    },
  ];

  const getFanListData = (val) => {
    if (!val?.fanData) return [];

    return val.fanData.map((participant) => ({
      name: participant?.name || "N/A",
      email: participant?.email || "N/A",
      paid:
        parseFloat(val?.timeslotData?.perParticipantAmount || 0) !== 0
          ? `${(
              parseFloat(val?.timeslotData?.perParticipantAmount || 0) + 0.5
            ).toFixed(2)}$`
          : "0$",
    }));
  };

  const renderOneOnOneChatActions = (row) => (
    <Button
      color="primary"
      className="text-sl px-3 py-2"
      onClick={() => {
        handleButtonClick3(
          oneononechat.findIndex((item) => item === row.originalData)
        );
      }}
    >
      Payout
    </Button>
  );

  const renderGroupChatActions = (row) => (
    <>
      <Button
        color="primary"
        className="text-sl px-3 py-2 me-2"
        onClick={() =>
          handleButtonClick(
            groupchat.findIndex((item) => item === row.originalData)
          )
        }
      >
        View
      </Button>
      <Button
        color="primary"
        className="text-sl px-3 py-2"
        onClick={() =>
          handleButtonClick2(
            groupchat.findIndex((item) => item === row.originalData)
          )
        }
      >
        Payout
      </Button>
    </>
  );

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card>
          <div className="pb-2">
            <Nav
              tabs
              className="d-flex justify-content-start text-dark athlete_earning-nav"
            >
              <NavItem className="px-1">
                <NavLink
                  className={
                    currentActiveTab === "1-on1chats"
                      ? "active active-tab py-2 "
                      : "text-dark cursor-pointer py-2 "
                  }
                  onClick={() => {
                    toggle("1-on1chats");
                    handleGetOneOnOneChat();
                  }}
                >
                  <h2
                    className={
                      currentActiveTab === "1-on1chats" ? "text-white" : ""
                    }
                  >
                    1-on1 chats
                  </h2>
                </NavLink>
              </NavItem>
              <NavItem className="px-1">
                <NavLink
                  className={
                    currentActiveTab === "Groupchats"
                      ? "active active-tab py-2 "
                      : "text-dark cursor-pointer py-2 "
                  }
                  onClick={() => {
                    toggle("Groupchats");
                    handleGetGroupChat();
                  }}
                >
                  <h2
                    className={
                      currentActiveTab === "Groupchats" ? "text-white" : ""
                    }
                  >
                    Group chats
                  </h2>
                </NavLink>
              </NavItem>
              <NavItem className="px-1">
                <NavLink
                  className={
                    currentActiveTab === "Stats"
                      ? "active active-tab py-2 "
                      : "text-dark cursor-pointer py-2"
                  }
                  onClick={() => {
                    toggle("Stats");
                    handleGetAdminEarningStats();
                  }}
                >
                  <h2
                    className={currentActiveTab === "Stats" ? "text-white" : ""}
                  >
                    Stats
                  </h2>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={currentActiveTab} className="py-2">
              <TabPane tabId="1-on1chats">
                <Row>
                  <Col sm="12">
                    {loader.data ? (
                      <div className="text-center my-4">
                        <Spinner color="primary" />
                      </div>
                    ) : (
                      <>
                        <TableComponent
                          columns={oneOnOneChatColumns}
                          data={transformedOneOnOneChat}
                          keyMap={oneOnOneChatKeyMap}
                          renderActions={renderOneOnOneChatActions}
                        />
                        {oneononechat.length > 4 && (
                          <div className="text-center py-4">
                            <Button
                              color="primary"
                              onClick={loadMoreOneOnOneChat}
                              disabled={loader.loadMore || !hasMoreOneononechat}
                            >
                              {loader.loadMore ? (
                                <Spinner size="sm" />
                              ) : (
                                "Load More"
                              )}
                            </Button>
                          </div>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </TabPane>

              {oneononechat?.map((value, index) => (
                <Modal
                  key={index}
                  isOpen={selectedObjectIndex3 === index && modal1}
                  toggle={handleButtonClick3}
                  {...args}
                  size="lg"
                  scrollable="true"
                >
                  <ModalBody>
                    <TableComponent
                      columns={payoutsColumns}
                      data={getPayoutData(value)}
                      keyMap={payoutsKeyMap}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      className="text-sl px-3 py-2"
                      onClick={handleButtonClick3}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              ))}

              <TabPane tabId="Groupchats" className="py-2">
                <Row>
                  <Col sm="12">
                    {loader.data ? (
                      <div className="text-center my-4">
                        <Spinner color="primary" />
                      </div>
                    ) : (
                      <>
                        <TableComponent
                          columns={groupChatColumns}
                          data={transformedGroupChat}
                          keyMap={groupChatKeyMap}
                          renderActions={renderGroupChatActions}
                        />
                        {groupchat.length > 4 && (
                          <div className="text-center py-4">
                            <Button
                              color="primary"
                              onClick={loadMoreGroupChat}
                              disabled={loader.loadMore || !hasMoreGroupchat}
                            >
                              {loader.loadMore ? (
                                <Spinner size="sm" />
                              ) : (
                                "Load More"
                              )}
                            </Button>
                          </div>
                        )}
                      </>
                    )}
                  </Col>
                </Row>
              </TabPane>

              {groupchat?.map((val, index) => (
                <Modal
                  key={index}
                  isOpen={selectedObjectIndex === index && modal2}
                  toggle={handleButtonClick}
                  {...args}
                  size="lg"
                  scrollable="true"
                >
                  <ModalBody>
                    <TableComponent
                      columns={fanListColumns}
                      data={getFanListData(val)}
                      keyMap={fanListKeyMap}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      className="text-sl px-3 py-2"
                      onClick={handleButtonClick}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              ))}

              {groupchat?.map((value, index) => (
                <Modal
                  key={index}
                  isOpen={selectedObjectIndex2 === index && modal3}
                  toggle={handleButtonClick2}
                  {...args}
                  size="lg"
                  scrollable="true"
                >
                  <ModalBody>
                    <TableComponent
                      columns={payoutsColumns}
                      data={getPayoutData(value)}
                      keyMap={payoutsKeyMap}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      className="text-sl px-3 py-2"
                      onClick={handleButtonClick2}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              ))}

              <TabPane tabId="Stats" className="py-2">
                <Row>
                  <Col sm="12">
                    {loader.data ? (
                      <div className="text-center my-4">
                        <Spinner color="primary" />
                      </div>
                    ) : (
                      <TableComponent
                        columns={statsColumns}
                        data={transformedStats}
                        keyMap={statsKeyMap}
                      />
                    )}
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </div>
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
};

export default A4BChat;
